import { StateContext } from "../../../../../state/stateContext";
import { useContext } from "react";
import { useLanguage } from "@utils/hooks/useLanguage";
import { useTranslations } from "../../../../../translation/TranslationContext";

interface ISubstituteNamesProps {
    ml: string;
    mr: string;
    startPosition?: "start" | "end";
    event_type: string;
    player_in: string;
    player_out: string;
    containerWidth?: number;
}


export const SubstituteNames = ({ 
    ml, 
    mr, 
    startPosition = 'end', 
    event_type, 
    player_in, 
    player_out, 
    containerWidth 
    }: ISubstituteNamesProps) => {
        const ctx = useContext(StateContext);
        const { stContext, setStContext } = ctx || {};
        const { overviewEventAndTimeWidth } = stContext || {};
        const language = useLanguage();
        const t = useTranslations(language);

        return (
            <div data-test-id="substitute-names" className={`flex flex-col justify-center`} 
                 style={{ 
                    marginLeft: ml, 
                    marginRight: mr, 
                    alignItems: "flex-" + startPosition,
                    maxWidth: containerWidth ? `${containerWidth-(overviewEventAndTimeWidth || 0)-8-((overviewEventAndTimeWidth || 0)-16)/2}px` : '230px'
                }}>
                <div data-testid="substitute-names-in" className={`text-base120 dark:text-monoY text-[12px] leading-[16px] font-medium font-robotoMedium
                    whitespace-nowrap text-ellipsis overflow-x-hidden overflow-y-visible w-full`}>
                        {t[`InHouseStats.OverviewSubIn`]}: {player_in}
                </div>
                <div data-testid="substitute-names-out" className={`text-base0 dark:text-base090 text-[12px] leading-[16px] font-normal font-robotoRegular
                    whitespace-nowrap text-ellipsis overflow-x-hidden overflow-y-visible w-full`}>
                        {t[`InHouseStats.OverviewSubOut`]}: {player_out}
                </div>
            </div>
        )
}